module.exports = __webpack_public_path__ + "img/title-5.2d2a7f7b.png";